import React, { useEffect } from 'react';
import { ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import Circle from 'assets/images/circle.png';
import Logo from 'assets/images/logoWhite.png';

const SiPayPanelInitialLoading: React.FC<ConnectedProps<typeof connector>> = function (
    props: ConnectedProps<typeof connector>,
) {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);
    return (
        <div className="w-screen h-screen absolute top-0 left-0 z-50 bg-primary-100 flex items-center justify-center overflow-hidden">
            <img className="absolute animate-scale z-10 opacity-25" src={Circle} alt="30pay" />
            <img className="z-20 w-[224px]" src={Logo} alt="30pay" />
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(SiPayPanelInitialLoading);
